import { BarChartDimension } from "@src/components/core/BarChart";

export function sortedParticipationSegment(data: BarChartDimension) {
    return Object.fromEntries(Object.entries(data).sort(function(firstKey, secondKey){
        return secondKey[1].total - firstKey[1].total;
      }));
  }
  